<template>
  <z-dialogo
    ref="dialogo"
    titulo="Produtos"
    scrollable
    dividers
    no-padding
    largura="800px"
    altura="383px"
  >
    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <v-text-field
          ref="busca"
          v-model="busca.descricao"
          rounded
          outlined
          single-line
          dense
          label="Pesquisar"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="buscar"
          @focus="onBuscaFocus"
          @click:clear="limparBusca"
        ></v-text-field>
      </v-toolbar>
    </template>

    <template v-slot:texto>
      <v-data-table
        disable-pagination
        disable-sort
        hide-default-footer
        :headers="headers"
        :items="produtos"
        :loading="carregando"
        fixed-header
        height="383px"
      >
        <template v-slot:item="{ item: produto }">
          <tr @click="selecionar(produto)" style="cursor: pointer">
            <td>{{ produto.referencia }}</td>
            <td>{{ produto.lotes }}</td>
            <td>
              <div>{{ produto.descricao }}</div>
              <template v-if="produto.variacoes">
                <v-chip
                  v-for="(variacao, index) in produto.variacoes"
                  class="mr-2"
                  x-small 
                  color="grey lighten-2"
                  :key="index"
                >{{variacao.descricao}}</v-chip>
              </template>
            </td>
            <td class="text-right">{{ produto.estoque | valorBR(0) }} {{ produto.unidade }}</td>
            <td class="text-right">{{ produto.valor_venda | valorBR }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Produtos encontrados: {{ produtos.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn color="primary" @click="fechar()">Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import produtosApi from "@/app/services/produtos";

export default {
  name: "DialogoBuscarProduto",

  data() {
    return {
      produtos: [],
      busca: {
        descricao: ''
      },
      headers: [
        { text: "Referência", value: "referencia", width: "90px" },
        { text: "Lote", value: "lote_id", width: "90px" },
        { text: "Descrição", value: "descricao" },
        { text: "Estoque", value: "estoque", align: "right" },
        { text: "Valor", value: "valor_venda", align: "right" },
      ],
      carregando: false,
    };
  },

  methods: {
    abrir() {
      this.$refs.dialogo.abrir();
      this.setFocus("busca", 300);
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    async buscar(event) {
      try {
        if (this.busca.descricao && this.busca.descricao.length > 0) {
          if (event) {
            event.target.select();
          }

          this.carregando = true;
          this.produtos = await produtosApi.buscarProdutoPorDescricao({...this.busca});
        }
      } catch (error) {
        this.$eventbus.erroSistema(error);
      } finally {
        this.carregando = false;
      }
    },

    selecionar(produto) {
      this.$emit("selecionar:produto", produto);
      this.fechar();
    },

    onBuscaFocus(event) {
      event.target.select();
    },

    limparBusca() {
      this.busca = "";
      this.produtos = [];
      // this.buscar();
    },
  },
};
</script>

<style scoped></style>
